import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchPromisesClient(id) {
  const url = `/contacts/clients/${id}/promises/`;
  const response = await httpManager.get(url);

  return response.data;
}
